import React, { useState } from "react";
import BasePage from "./basePage";
export const RouteContext = React.createContext(null);
const RoutsLayout = () => {
  const [path, setPath] = useState("");
  const handleState = (aa) => {
    setPath(aa);
  };

  return (
    <>
      <RouteContext.Provider value={{ path: path, setPath: handleState }}>
        <BasePage />
      </RouteContext.Provider>
    </>
  );
};

export default RoutsLayout;
